/**
 * Exam Type API Service
 * Handles all exam type-related API calls
 */
import apiService from './apiService';

class ExamTypeService {
  /**
   * Endpoint base path
   */
  basePath = '/api/examtype';
  
  /**
   * Get all exam types with optional filters
   * @param {Object} params - Filter parameters
   * @param {string} [params.Name] - The name of the exam type to filter by (partial match)
   * @param {string} [params.Description] - The description of the exam type to filter by (partial match)
   * @returns {Promise<Array>} - Array of exam types
   */
 async getExamTypes(params = {}) {
  try {
    // console.log('Calling API:', this.basePath, 'with params:', params);
    // console.log('[examTypeService] 📍 Call stack:', new Error().stack.split('\n').slice(0, 8).join('\n'));
    const response = await apiService.get(this.basePath, params, 'examTypeService.getExamTypes');
    // console.log('API Response:', response);
    return response;
  } catch (error) {
    console.error('Error fetching exam types:', error);
    throw error;
  }
}

  
  /**
   * Get a specific exam type by ID
   * @param {number} id - The ID of the exam type to retrieve
   * @returns {Promise<Object>} - The exam type details
   */
  async getExamTypeById(id) {
    try {
      // console.log(`Calling API: ${this.basePath}/${id}`);
      const response = await apiService.get(`${this.basePath}/${id}`);
      // console.log('API Response:', response);
      return response;
    } catch (error) {
      console.error(`Error fetching exam type with ID ${id}:`, error);
      throw error;
    }
  }
}

// Export singleton instance
export default new ExamTypeService();